
        <ng-content></ng-content>
    


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/grid/row/row.component.ts.RowComponent.html